import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formState: "login",
  isLoading: false,
  error: null,
};

const emailLoginSlice = createSlice({
  name: "emailLogin",
  initialState,
  reducers: {
    setFormState: (state, action) => {
      state.formState = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetError: (state) => {
      state.error = null;
    },
  },
});

export const { setFormState, setLoading, setError, resetError } =
  emailLoginSlice.actions;
export default emailLoginSlice.reducer;
